import { render, staticRenderFns } from "./TransactionAdd.vue?vue&type=template&id=10fa17c0&scoped=true&"
import script from "./TransactionAdd.vue?vue&type=script&lang=js&"
export * from "./TransactionAdd.vue?vue&type=script&lang=js&"
import style0 from "./TransactionAdd.vue?vue&type=style&index=0&id=10fa17c0&lang=scss&scoped=true&"
import style1 from "./TransactionAdd.vue?vue&type=style&index=1&id=10fa17c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa17c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fa17c0')) {
      api.createRecord('10fa17c0', component.options)
    } else {
      api.reload('10fa17c0', component.options)
    }
    module.hot.accept("./TransactionAdd.vue?vue&type=template&id=10fa17c0&scoped=true&", function () {
      api.rerender('10fa17c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/transactions/TransactionAdd.vue"
export default component.exports